import React from "react";
import LegalPageLayout from "./LegalPageLayout";
import { PRIVACY_POLICY_URL } from "../appPublicUrls";

const SUPPORT_EMAIL = "info@quizmasterbob.com.au";

export default function SupportPage() {
  return (
    <LegalPageLayout title="Support">
      <p style={{ marginTop: 0 }}>
        Need help with the <strong>Quizmaster Bob Player</strong> app or joining a live quiz?
      </p>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>Joining a quiz</h2>
      <ol>
        <li>Ask the venue host for the 4-digit code on their screen.</li>
        <li>Open the player app and enter the code on the join screen.</li>
        <li>Register your team name and optional selfie, then play along.</li>
      </ol>
      <p>
        The host runs the quiz from the Quizmaster Bob website; players only need the code — no
        host account is required on your phone.
      </p>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>Common issues</h2>
      <ul>
        <li>
          <strong>Invalid code:</strong> the quiz may not have started or may have ended. Confirm
          the code with the host.
        </li>
        <li>
          <strong>Can&apos;t connect:</strong> check Wi‑Fi or mobile data; venue firewalls sometimes
          block new devices — try cellular if available.
        </li>
        <li>
          <strong>Camera / photos:</strong> allow camera and photo access when prompted for team
          selfies (Settings → Quizmaster Bob).
        </li>
      </ul>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>Contact</h2>
      <p>
        Email:{" "}
        <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: "#99ffc9" }}>
          {SUPPORT_EMAIL}
        </a>
      </p>
      <p>
        Privacy:{" "}
        <a href={PRIVACY_POLICY_URL} style={{ color: "#99ffc9" }}>
          Privacy policy
        </a>
      </p>

      <p style={{ fontSize: "0.85rem", opacity: 0.85, marginTop: 24 }}>
        Hosts and billing: use the Quizmaster Bob website login and account pages.
      </p>
    </LegalPageLayout>
  );
}
